import React from 'react'
import { SVGIconProps } from '../types'
const SvgMoreTime = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M10 8v6l4.7 2.9.8-1.2-4-2.4V8z" />
    <path d="M17.92 12A6.957 6.957 0 0 1 11 20c-3.9 0-7-3.1-7-7s3.1-7 7-7c.7 0 1.37.1 2 .29V4.23c-.64-.15-1.31-.23-2-.23-5 0-9 4-9 9s4 9 9 9a8.963 8.963 0 0 0 8.94-10z" />
    <path d="M20 5V2h-2v3h-3v2h3v3h2V7h3V5z" />
  </svg>
)
export default SvgMoreTime
